var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actualization-btns"},[_c('b-button',{on:{"click":function($event){return _vm.$emit('closeModal')}}},[_vm._v("Отменить")]),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.onConfirm}},[_vm._v("Подтвердить")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }